import React from 'react';
import { Linkedin, Mail, FileText, Shield, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Logo & Description */}
          <div className="footer-brand">
            <div className="footer-logo">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                <rect width="40" height="40" rx="8" fill="#00FFD1" fillOpacity="0.1"/>
                <path d="M12 20L18 14L24 20L30 14" stroke="#00FFD1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 26L18 20L24 26L30 20" stroke="#00FFD1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className="footer-logo-text">Doctimize</span>
            </div>
            <p className="footer-description">
              Intelligente Dokumenten-Automatisierung für Schweizer Unternehmen
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-title">Navigation</h4>
            <ul className="footer-links">
              <li><a href="#problem">Problem</a></li>
              <li><a href="#solution">Lösung</a></li>
              <li><a href="#pricing">Preise</a></li>
              <li><a href="#about">Über uns</a></li>
              <li><a href="#contact">Kontakt</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="footer-section">
            <h4 className="footer-title">Rechtliches</h4>
            <ul className="footer-links">
              <li>
                <a href="#impressum">
                  <FileText size={16} />
                  Impressum
                </a>
              </li>
              <li>
                <a href="#datenschutz">
                  <Shield size={16} />
                  Datenschutz
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h4 className="footer-title">Kontakt</h4>
            <ul className="footer-links">
              <li>
                <a href="mailto:info@doctimize.ch">
                  <Mail size={16} />
                  info@doctimize.ch
                </a>
              </li>
              <li>
                <a href="tel:+41772770546">
                  <Phone size={16} />
                  +41 77 277 05 46
                </a>
              </li>
              <li>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                  <Linkedin size={16} />
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Doctimize. Alle Rechte vorbehalten.
          </p>
          <p className="footer-location">
            Made in Switzerland 🇨🇭
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
